export default __webpack_public_path__ + "assets/img/Details.6ac6f602.svg";